export const SET = 'config/SET'
export const SET_DEEP_LINK_PATH = 'config/SET_DEEP_LINK_PATH'
